import { Box, Modal, Typography, Slide, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '1em'
	},
	box: {
		maxHeight: '90vh',
		boxShadow: 24,
		display: 'flex',
		flexDirection: 'column',
		borderRadius: '2em',
		backgroundColor: theme.palette.background.paper
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		color: theme.palette.secondary.value,
		padding: theme.spacing(2)
	}
}));

const ModalOmni = (
	{
		open,
		handleClose,
		title,
		content,
		actions,
		customWidth,
		hideScroll,
		ForceBgWhite,
		disableBackdropClick = false,
		disableEscapeKeyDown = false,
		hideCloseButton = false
	},
	props
) => {
	const classes = useStyles(props);
	const handleModalClose = (event, reason) => {
		if (disableBackdropClick && reason === 'backdropClick') {
			return;
		}
		if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
			return;
		}
		handleClose();
	};
	return (
		<Modal
			open={open}
			onClose={handleModalClose}
			aria-labelledby="modal-title"
			aria-describedby="modal-description"
			className={classes.modal}
		>
			<Box
				sx={{
					width: customWidth || 400,
					bgcolor: ForceBgWhite ? 'white' : 'background.paper'
				}}
				className={classes.box}
			>
				<Box className={classes.header}>
					<Typography variant="h5" id="modal-title" className="text-center flex-grow-1">
						{title
							? title
									.toLowerCase()
									.split(' ')
									.map(word => word.charAt(0).toUpperCase() + word.slice(1))
									.join(' ')
							: ''}
					</Typography>

					{!hideCloseButton && (
						<IconButton aria-label="close" onClick={() => handleClose && handleClose()} size="small">
							<CloseIcon />
						</IconButton>
					)}
				</Box>

				<hr />

				<Box
					id="modal-description"
					sx={{
						overflowY: hideScroll || 'auto',
						flexGrow: 1,
						maxHeight: '80vh'
					}}
				>
					{content}
				</Box>

				<Box m={2} display="flex" justifyContent="space-between">
					{actions}
				</Box>
			</Box>
		</Modal>
	);
};

export default ModalOmni;
